import ApiClient from './ApiClient';

class ContactNotes extends ApiClient {
  constructor() {
    super('notes', { accountScoped: true });
    this.contactId = null;
  }

  get url() {
    return `${this.baseUrl()}/contacts/${this.contactId}/notes`;
  }

  get(contactId) {
    this.contactId = contactId;
    return super.get();
  }

  create(contactId, content) {
    this.contactId = contactId;
    return super.create({ content });
  }

  // BonBoZ: mot endpoint cho ca sua noi dung lan ghim/bo ghim. Chi gui field
  // nao thuc su doi - server bo qua field khong co trong payload.
  //
  // Goi trong `note` mot cach tuong minh. Rails tu goi tham so theo TEN COT cua
  // model, ma `pinned` khong phai cot (cot that la `pinned_at`), nen de Rails tu
  // goi thi `pinned` bi loai am tham va lenh ghim khong lam gi ca.
  update(contactId, id, payload) {
    this.contactId = contactId;
    return super.update(id, { note: payload });
  }

  delete(contactId, id) {
    this.contactId = contactId;
    return super.delete(id);
  }
}

export default new ContactNotes();
